module.exports = __webpack_public_path__ + "images/emoji/angry.f0964c2a3b65f161c015.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/angry.png
// module id = UZfl
// module chunks = 13